import React from 'react';

import { cn } from '@/lib/utils'

import { Skeleton } from './skeleton';

export function PageSkeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <>
      <div
        className={cn("grid auto-rows-min gap-4 md:grid-cols-3", className)}
        {...props}
      >
        <Skeleton className="bg-blue-100/50 rounded-xl aspect-video"/>
        <Skeleton className="bg-blue-100/50 rounded-xl aspect-video"/>
        <Skeleton className="bg-blue-100/50 rounded-xl aspect-video"/>
      </div>
      <Skeleton className="min-h-screen flex-1 rounded-xl bg-blue-100/50 md:min-h-min"/>
    </>
  )
}